import { parseISO } from 'date-fns'

import DateManager from '@/logic/DateManager'

const MAX_BROWSER_TIMEOUT_DELAY = 2_147_483_647

export default function scheduleParticipationDeadlineTransitions(deadlineExpirationValues, updateDeadlineNow) {
  let deadlineRefreshTimeoutId = null

  const stopDeadlineRefresh = () => {
    window.clearTimeout(deadlineRefreshTimeoutId)
    deadlineRefreshTimeoutId = null
  }

  const scheduleNextDeadlineRefresh = () => {
    stopDeadlineRefresh()

    const deadlineNow = DateManager.now().getTime()
    updateDeadlineNow(deadlineNow)

    const nextDeadlineExpiration = deadlineExpirationValues
      .filter(Boolean)
      .map((deadlineExpiresAt) => parseISO(deadlineExpiresAt).getTime())
      .filter((deadlineExpiration) => deadlineExpiration >= deadlineNow)
      .sort((firstExpiration, secondExpiration) => firstExpiration - secondExpiration)[0]

    if (nextDeadlineExpiration === undefined) {
      return
    }

    const refreshDelay = Math.min(
      nextDeadlineExpiration - deadlineNow + 1,
      MAX_BROWSER_TIMEOUT_DELAY,
    )
    // A one-shot timeout updates deadline-dependent UI at expiry; browser-length limits are capped and rescheduled until then.
    deadlineRefreshTimeoutId = window.setTimeout(scheduleNextDeadlineRefresh, refreshDelay)
  }

  scheduleNextDeadlineRefresh()

  return stopDeadlineRefresh
}
